module.exports = __webpack_public_path__ + "img/TimeRange.889606bf.svg";